export default __webpack_public_path__ + "static/gamerize-1-3f2dab0a4355b46c14ce8c96b46d064f.webp";